import ViewToolsContainer from "../../../../boundarySelection/ViewTools/ViewToolsContainer";
import RouteLineQuarterDropdown from "./RouteLineQuarterDropdown";

const RouteLineViewTools = () => {
  return (
    <ViewToolsContainer>
      <RouteLineQuarterDropdown />
    </ViewToolsContainer>
  );
};

export default RouteLineViewTools;
